<script>
import ImageUploader from "@/components/file-uploader/ImageUploader.vue";
import {ElNotification} from "element-plus";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: 'PopupForm',
  components: {ImageUploader},
  data() {
    return {
      loading: false,
      popupId: null,
      form: {
        content: {
          uz_lat: null,
          uz_cyr: null,
          ru: null,
          en: null,
          kr: null
        },
        image: {
          uz_lat: null,
          uz_cyr: null,
          ru: null,
          en: null,
          kr: null
        },
        is_active: false
      },
      editor: ClassicEditor,
      editorData: '',
      rules: {
        content: {
          uz_lat: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          uz_cyr: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          en: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          ru: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
          kr: [{required: true, message: "Majburiy maydon", trigger: "blur"}]
        }
      }
    }
  },
  methods: {
    handleChange(image) {
      this.form.image[image.type] = image.hashId;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let httpTemp;
          if (this.popupId) {
            httpTemp = this.$http.put(`/api/v1/popups/${this.popupId}`, this.form)
          } else {
            httpTemp = this.$http.post('/api/v1/popups', this.form)
          }

          httpTemp.then(() => {
            ElNotification({
              message: "Ma'lumotlar saqlandi!",
              type: "success",
            });
            this.$router.go(-1);
          })
              .catch(({response}) => {
                ElNotification({
                  title: "Ogohlantirish",
                  message:
                      response.data.message ||
                      "Ma'lumot saqlashda xatolik sodir bo'ldi!",
                  type: "warning",
                });
              })
              .finally(() => {
                this.loading = false
              })
        }
      })
    },
    getPopupById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/popups/${this.popupId}`)
          .then(({data}) => {
            this.form = data;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.popupId = this.$route.params.id;
      this.getPopupById()
    }
  }
}
</script>

<template>
  <div class="popup-form">
    <el-form ref="form" :model="form" :rules="rules" label-position="top" v-loading="loading">
      <fieldset class="fieldset">
        <legend>Content</legend>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="O'zbek" prop="content.uz_lat">
              <div style="width: 100%;">
                <ckeditor style="width: 100%;"
                          :editor="editor"
                          v-model="form.content.uz_lat"
                          :config="editorConfig"></ckeditor>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="Ўзбек" prop="content.uz_cyr">
              <div style="width: 100%">
                <ckeditor style="width: 100%"
                          :editor="editor"
                          v-model="form.content.uz_cyr"
                          :config="editorConfig"></ckeditor>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="Русский" prop="content.ru">
              <div style="width: 100%">
                <ckeditor style="width: 100%;"
                          :editor="editor"
                          v-model="form.content.ru"
                          :config="editorConfig"></ckeditor>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="English" prop="content.en">
              <div style="width: 100%">
                <ckeditor style="width: 100%"
                          :editor="editor"
                          v-model="form.content.en"
                          :config="editorConfig"></ckeditor>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="Qoraqalpoq" prop="content.kr">
              <div style="width: 100%">
                <ckeditor style="width: 100%"
                          :editor="editor"
                          v-model="form.content.kr"
                          :config="editorConfig"></ckeditor>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
      <fieldset class="fieldset">
        <legend>Rasmlar</legend>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="O'zbek" prop="image.uz_lat">
              <image-uploader @handleChange="handleChange" image-type="uz_lat" :hash-id="form.image.uz_lat"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="Ўзбек" prop="image.uz_cyr">
              <image-uploader @handleChange="handleChange" image-type="uz_cyr" :hash-id="form.image.uz_cyr"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="Русский" prop="image.ru">
              <image-uploader @handleChange="handleChange" image-type="ru" :hash-id="form.image.ru"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="English" prop="image.en">
              <image-uploader @handleChange="handleChange" image-type="en" :hash-id="form.image.en"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="Qoraqalpoq" prop="image.kr">
              <image-uploader @handleChange="handleChange" image-type="kr" :hash-id="form.image.kr"/>
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
      <el-form-item>
        <el-checkbox v-model="form.is_active" :label="form.is_active?'Aktiv':'Aktiv emas'" size="large" border/>
      </el-form-item>
      <el-row>
        <el-col :span="24" style="display: flex;justify-content: flex-end">
          <el-form-item>
            <el-button class="custom-btn" @click="() => this.$router.go(-1)">
              Orqaga
            </el-button>
            <el-button class="custom-btn" type="primary" @click="onSubmit">
              Saqlash
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<style scoped>
.fieldset {
  padding: 10px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  margin-bottom: 20px;

  legend {
    font-weight: bold;
    font-size: 18px;
  }
}
</style>
